// extracted by mini-css-extract-plugin
export default {"dragPreview":"DelayProfileDragPreview-dragPreview-addkn"};